module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_articles_grand_title-b4dcac1e8a5ff1e8d223f4cafd7c5e4e.svg";